export const APP_URL = {
  THEMES: '/themes',
  IFRAME: '/sign-up-iframe',
  SIGN_IN: '/sign-in',
  COURSES: '/courses',
  MY_COURSES: '/my-courses',
  COURSE: '/course/:id',
  COURSE_ENROLLMENT: '/course-enrollment/:id',
  PASSWORD_RECOVERY: '/password-recovery',
  PASSWORD_RECOVERY_COMPLETE: '/password-recovery-complete',
  PROFILE: '/profile',
  USER_TESTS: '/my-tests',
  TESTING_PAGE: '/question-group/:id',
  ABOUT: '/about',
  SUPPORT: '/support',
  QUESTION_GROUPS: '/themes/:id',
  QUESTION_GROUP: '/question-group',
  COMPLETED: '/completed/:id',
  PAYMENT_SUCCEEDED: '/payment-success',
  PAYMENT_FAILED: '/payment-failed',
  SIGN_UP: '/sign-up',
};

export const ENDPOINT = {
  CITIES: 'cities',
  PROFILE: 'profile',
  CATEGORIES: 'categories',
  THEMES: 'themes',
  TARIFFS: 'tariffs',
  QUESTION_GROUPS: 'question-groups',
  QUESTIONS: 'questions',
  SESSIONS: 'sessions',
  ORDERS: 'orders',
  // LMS endpoints — Phase 6
  COURSES: 'courses',
  CONTRACTS: 'contracts',
  CONTRACTS_MINE: 'contracts/mine',
  CLIENTS_IMNS: 'clients/imns',
  LISTENERS_PREVIOUS: 'listeners/previous',
};

export const DATA = {
  NOT_FOUND: 'По Вашему запросу нет данных.',
  NO_FINISHED: 'У Вас нет завершенных тестов.',
  NO_UNFINISHED: 'У Вас нет незавершенных тестов.',
};

export const RETURN_TO_THE_MAIN_PAGE = 'Вернуться на главную страницу';

export const STORAGE_KEYS = {
  TYPE: 'type',
} as const;

export const STORAGE_VALUES = {
  course: 'course',
} as const;
